import { Resource } from 'modules/core/base-resource';
import httpResource from 'modules/core/http-resource';
import { AvailableTournamentDataMapper } from '../data-mappers/available-tournament.data-mapper';
import { AvailableTournamentDto } from '../dtos/available-tournament.dto';
import { AuthAvailableTournament } from '../interfaces/auth-available-tournament';
import { AuthRequestAuthCodePayload } from '../interfaces/auth-request-auth-code-payload';
import { AuthSignInPayload } from '../interfaces/auth-sign-in-payload';
import { AuthSignInResponse } from '../interfaces/auth-sign-in-response';
import { AuthSignUpPayload } from '../interfaces/auth-sign-up-payload';
import { AuthSignUpResponse } from '../interfaces/auth-sign-up-response';
import { AuthTempPasswordResponse } from '../interfaces/auth-temp-password-response';

class AuthResource extends Resource {
  constructor() {
    super('users', httpResource);
  }

  public async requestAuthCode(data: AuthRequestAuthCodePayload): Promise<AuthTempPasswordResponse> {
    return this.child('get-temp-password-v2').post<AuthTempPasswordResponse>(data);
  }

  public signIn(data: AuthSignInPayload): Promise<AuthSignInResponse> {
    try {
      return this.absolute('login_check').post(data);
    } catch (err) {
      throw new Error('Invalid credentials');
    }
  }

  public async signUp(data: AuthSignUpPayload): Promise<AuthSignUpResponse> {
    const { firstName: name, lastName: surname, middleName, phone, sportType, tournamentName } = data;

    return this.child('register').post({
      name,
      surname,
      middleName,
      phone,
      sportType,
      tournamentName,
      roles: ['ROLE_TOURNAMENT_ADMIN'],
    });
  }

  public check(): Promise<AuthSignInResponse['user']> {
    return this.child('current').get();
  }

  /**
   * Точечная проверка «есть ли у пользователя организаторы» при старте сессии.
   * Список для UI грузится через RTK Query — `useListAvailableTournamentsQuery`.
   */
  public async getAvailableTournaments(params?: { limit?: number; offset?: number }): Promise<AuthAvailableTournament[]> {
    const { limit = 10, offset = 0 } = params || {};
    const tournaments = await this.absolute('/tournaments').get<AvailableTournamentDto[]>({ limit, offset });
    const mapper = new AvailableTournamentDataMapper();

    return (tournaments ?? []).map((item) => mapper.decode(item));
  }
}

const authResource = new AuthResource();
export default authResource;
